export const fetchHistory = async () => {
  const response = await fetch('/api/v1/tasks');
  if (!response.ok) {
    throw new Error('Failed to fetch history');
  }
  const data = (await response.json()).data;
  return data.filter(task => task.has_terminology_dict);
};

export const fetchTerminologyDict = async (uuid) => {
  const response = await fetch(`/api/v1/terminology_dict?uuid=${uuid}`);
  if (!response.ok) {
    throw new Error('Failed to fetch terminology dictionary.');
  }
  const dictData = await response.json();
  if (dictData && dictData.terminology_dict) {
    const parsedDict = JSON.parse(dictData.terminology_dict);
    return parsedDict;
  }
  return [];
};